import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MapPin, Phone, Mail, Clock, PhoneCall } from "lucide-react";
import { FaCheckCircle, FaFacebookF, FaInstagram, FaWhatsapp, FaSnapchatGhost, FaTiktok, FaYoutube } from "react-icons/fa";
import { SiX } from "react-icons/si";

export default function Contact() {
  const [showToast, setShowToast] = useState(false);

  const handleSubmit = async (e) => {
  e.preventDefault();

  const form = e.target;

  const payload = {
    firstName: form.firstName.value.trim(),
    lastName: form.lastName.value.trim(),
    email: form.email.value.trim(),
    phone: form.phone.value.trim(),
    service: form.service.value,
    message: form.message.value.trim(),
  };

  if (
    !payload.firstName ||
    !payload.lastName ||
    !payload.email ||
    !payload.phone ||
    !payload.service ||
    !payload.message
  ) {
    alert("يرجى تعبئة جميع الحقول قبل الإرسال");
    return;
  }

  try {
    const res = await fetch("/api/save_contact.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (data.status === "success") {
      setShowToast(true);
      form.reset();
      setTimeout(() => setShowToast(false), 3000);
    } else {
      alert("حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى.");
    }
  } catch (err) {
    console.error(err);
    alert("خطأ في الاتصال بالخادم");
  }
};
  return (
    <div className="pt-32 pb-24 bg-gradient-to-b from-[#e8e9eb] to-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Page Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="font-cairo font-bold text-4xl text-[#141d3c] mb-6 leading-tight">
            تـواصـل مـعـنـا
          </h1>
          <p className="font-cairo text-xl text-gray-600 max-w-3xl mx-auto leading-[1.618]">
            نحن هنا للإجابة على جميع استفساراتك ومساعدتك بكل ما تحتاج. لا تتردد في التواصل معنا !
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-[clamp(1rem,2vw,2.5rem)]">
          {/* Contact Information */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-[1.2em]"
          >
            {/* Address */}
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-[#e8e9eb]/20">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#141d3c]/10 rounded-2xl flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-[#141d3c]" />
                </div>
                <div>
                  <h3 className="font-cairo text-xl font-bold text-[#141d3c] mb-2">مـواقـعـنـا</h3>
                  <p className="font-cairo leading-[1.618] text-gray-600">
                    <strong>الإدارة الرئيسية:</strong> جدة – التحلية – شارع الحارث بن العاص <br />
                    <strong>الفروع:</strong> <br />
                    • القنفذة / الناعمية - طريق الملك فيصل بن عبدالعزيز<br />
                    • جازان / فرع المنطقة الجنوبية (قريبًا 2026)
                  </p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-[#141d3c]/20">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#141d3c]/10 rounded-2xl flex items-center justify-center">
                  <Phone className="w-6 h-6 text-[#141d3c]" />
                </div>
                <div>
                  <h3 className="font-cairo text-xl font-bold text-[#141d3c] mb-2">الـرقـم الـمـوحـد:</h3>
                  <div className="font-cairo text-gray-600 space-y-3">
                    <p className="text-lg font-semibold text-[#141d3c]">
                      +966 57 937 9779
                    </p>
                    <div className="flex gap-3">
                      <a
                        href="tel:+966579379779"
                        className="flex items-center gap-2 px-4 py-2 rounded-xl bg-[#141d3c]/10 text-[#141d3c] hover:bg-[#141d3c] hover:text-white transition-all duration-300 text-sm font-medium"
                      >
                        <PhoneCall className="w-4 h-4" />
                        اتصال
                      </a>

                      <a
                        href="https://wa.me/966579379779"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-4 py-2 rounded-xl bg-green-100 text-green-700 hover:bg-green-600 hover:text-white transition-all duration-300 text-sm font-medium"
                      >
                        <FaWhatsapp className="w-4 h-4" />
                        واتساب
                      </a>
                    </div>
                    <span className="font-cairo text-xs text-gray-500">
                      مـتـاح لـخـدمـتـكـم عـلـى مـدار الـسـاعـة
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-[#141d3c]/20">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#141d3c]/10 rounded-2xl flex items-center justify-center">
                  <Mail className="w-6 h-6 text-[#141d3c]" />
                </div>
                <div>
                  <h3 className="font-cairo text-xl font-bold text-[#141d3c] mb-2">الـبـريـد الإلـكـتـرونـي:</h3>
                  <div className="font-cairo text-gray-600 space-y-3">
                    <a
                      href="mailto:info@zan-mkt.com"
                      className="text-lg font-semibold text-[#141d3c] hover:underline"
                    >
                      info@zan-mkt.com
                    </a>
                    <span className="font-cairo text-xs text-gray-500 block">
                      نـحـن هـنـا لـمـسـاعـدتـكـم دائـمـاً
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-[#141d3c]/20">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#141d3c]/10 rounded-2xl flex items-center justify-center">
                  <Clock className="w-5 h-5 text-[#141d3c]" />
                </div>
                <div>
                  <h3 className="font-cairo text-xl font-bold text-[#141d3c] mb-2">اوقـات العمـل</h3>
                  <div className="font-cairo text-gray-600 space-y-1 leading-[1.618]">
                    <p>الأحـد: من 8 صباحًا إلى 11 مساءً</p>
                    <p>الإثنـين: من 8 صباحًا إلى 11 مساءً</p>
                    <p>الثـلاثـاء: من 8 صباحًا إلى 11 مساءً</p>
                    <p>الأربعـاء: من 8 صباحًا إلى 11 مساءً</p>
                    <p>الخميـس: من 8 صباحًا إلى 11 مساءً</p>
                    <p>الجمعة: من 4 عصـرًا إلى 11 مساءً</p>
                    <p>السبـت: من 8 صباحًا إلى 11 مساءً</p>
                  </div>
                </div>
              </div>
            </div>

          {/* Social Media */}
<div className="bg-white rounded-3xl p-8 shadow-lg border border-[#141d3c]/20">
  <h3 className="font-serif text-xl font-bold text-[#0F0F0F] mb-4">Follow Us</h3>

  <div className="flex gap-4">

    {/* Instagram */}
    <a 
      href="https://www.instagram.com/zan_mkt" 
      target="_blank"
      rel="noopener noreferrer"
      className="w-12 h-12 bg-[#141d3c] rounded-2xl flex items-center justify-center hover:bg-[#ee9805] transition-colors duration-300 text-white"
    >
      <FaInstagram className="w-6 h-6" />
    </a>

    {/* WhatsApp */}
    <a 
      href="https://wa.me/966579379779" 
      target="_blank"
      rel="noopener noreferrer"
      className="w-12 h-12 bg-[#141d3c] rounded-2xl flex items-center justify-center hover:bg-[#ee9805] transition-colors duration-300 text-white"
    >
      <FaWhatsapp className="w-6 h-6" />
    </a>

    {/* Snapchat */}
    <a 
      href="https://snapchat.com/t/b6iUvDS1" 
      target="_blank"
      rel="noopener noreferrer"
      className="w-12 h-12 bg-[#141d3c] rounded-2xl flex items-center justify-center hover:bg-[#ee9805] transition-colors duration-300 text-white"
    >
      <FaSnapchatGhost className="w-6 h-6" />
    </a>

    {/* X */}
    <a 
      href="https://x.com/zan_mkt" 
      target="_blank"
      rel="noopener noreferrer"
      className="w-12 h-12 bg-[#141d3c] rounded-2xl flex items-center justify-center hover:bg-[#ee9805] transition-colors duration-300 text-white"
    >
      <SiX className="w-6 h-6 text-white" />
    </a> 

    {/* TikTok */}
    <a 
      href="https://www.tiktok.com/@zan.mkt" 
      target="_blank"
      rel="noopener noreferrer"
      className="w-12 h-12 bg-[#141d3c] rounded-2xl flex items-center justify-center hover:bg-[#ee9805] transition-colors duration-300 text-white"
    >
      <FaTiktok className="w-6 h-6 text-white" />
    </a> 

    {/* YouTube (إذا ما عندك رابط خليه # مؤقت) */}
    <a 
      href="#" 
      className="w-12 h-12 bg-[#141d3c] rounded-2xl flex items-center justify-center hover:bg-[#ee9805] transition-colors duration-300 text-white"
    >
      <FaYoutube className="w-6 h-6 text-white" />
    </a>

  </div>
</div>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-white rounded-3xl p-8 shadow-lg border border-[#141d3c]/20 relative"
          >
            <h2 className="font-cairo text-4xl font-bold text-[#141d3c] mb-6">ارسـل لـنـا رسـالة</h2>
            
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="firstName" className="font-cairo block text-sm font-medium text-gray-700 mb-2">
                    الأسـم الأول
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    required
                    className="font-cairo w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-[#141d3c] transition-colors duration-300"
                    placeholder="اسمـك الأول"
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="font-cairo block text-sm font-medium text-gray-700 mb-2">
                    الأسـم الأخـيـر
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    required
                    className="font-cairo w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-[#141d3c] transition-colors duration-300"
                    placeholder="اسمـك الأخـيـر"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="email" className="font-cairo block text-sm font-medium text-gray-700 mb-2">
                  البـريـد الإلكترونـي
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="font-cairo w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-[#141d3c] transition-colors duration-300"
                  placeholder="your@email.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="font-cairo block text-sm font-medium text-gray-700 mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="font-cairo w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-[#141d3c] transition-colors duration-300"
                  placeholder="+966 5XX XXX XXX"
                />
              </div>

              <div>
                <label htmlFor="service" className="font-cairo block text-sm font-medium text-gray-700 mb-2">
                  الخـدمة المراد الإستفسار عنـها
                </label>
                <select
                  id="service"
                  name="service"
                  required
                  className="font-cairo w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-[#141d3c] transition-colors duration-300"
                >
                  <option value="">الرجـاء اختيـار الخـدمة</option>
                  <option value="تسويق">التسويق الرقمي</option>
                  <option value="تصوير">الإنتاج الإعلامي والتصوير</option>
                  <option value="طباعه">الطباعة والإنتاج المطبعي</option>
                  <option value="تنظيم فعاليات">تنظيم الفعاليات والإيفنتات</option>
                  <option value="استشارات">الاستشارات التسويقية</option>
                  <option value="تصميم">الهوية البصرية والعلامة التجارية</option>
                  <option value="اخرى">استفسار اخر</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  محتـوى الرسـالـة
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={4}
                  className="font-cairo w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-[#141d3c] transition-colors duration-300 resize-none"
                  placeholder="اكـتـب رسـالـتـك هـنـا..."
                />
              </div>

              <button
                type="submit"
                className="font-cairo w-full bg-[#141d3c] text-white py-4 rounded-xl font-medium hover:bg-[#ee9805] transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
              >
                إرسـال
              </button>
            </form>

            {/* Toast Notification أسفل اليمين */}
            <AnimatePresence>
              {showToast && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20 }}
                  transition={{ duration: 0.3 }}
                  className="fixed bottom-6 right-6 font-cairo bg-white text-[#141d3c] px-6 py-3 rounded-xl shadow-lg flex items-center gap-3 z-50"
                >
                  <FaCheckCircle className="text-green-500 w-6 h-6" />
                  <span>تم إرسال طلب التواصل بنجاح! سيتم التواصل معك قريبًا.</span>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
